module.exports = __webpack_public_path__ + "img/samsung-galaxy-s3.fefc702a.jpg";